(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["agp-product-recommendations"] && !Shopify.designMode) return;
  try {
    
// agp-reveal: WINDOWED progressive rendering for the recommendations grid.
// Only the initial window of cards is in the live DOM; the rest are parsed into an
// inert <template class="agp-rec-buffer"> (no layout/paint/image loads). As the user
// nears the last visible cell, the next data-step cells are MOVED out of the template
// into the grid. The full list was built (deduped + tiled) server-side, so moving any
// prefix keeps the 4/3 alternation perfect — and only ~visible cards ever render.
if (!customElements.get('agp-reveal')) {
  customElements.define('agp-reveal', class extends HTMLElement {
    connectedCallback() {
      this.step = parseInt(this.dataset.step, 10) || 12;
      this._buffer = this.querySelector(':scope > template.agp-rec-buffer');
      if (!this._buffer || !this._buffer.content.children.length) return;
      var self = this;
      this._io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) self._revealMore();
      }, { rootMargin: '800px 0px' });
      this._observeLast();
    }
    _observeLast() {
      var cells = this.querySelectorAll(':scope > .agp-rec-cell');
      this._sentinel = cells[cells.length - 1];
      if (this._sentinel) {
        this._io.observe(this._sentinel);
      } else {
        this._revealMore();
      }
    }
    _revealMore() {
      if (this._sentinel) this._io.unobserve(this._sentinel);
      var frag = this._buffer.content;
      var n = 0;
      while (frag.children.length && n < this.step) {
        // Move (adopt) the next buffered cell into the live grid, just before the <template>.
        this.insertBefore(frag.children[0], this._buffer);
        n += 1;
      }
      if (frag.children.length) {
        this._observeLast();
      } else {
        this._io.disconnect();
      }
    }
    disconnectedCallback() {
      if (this._io) this._io.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["agp-template"] && !Shopify.designMode) return;
  try {
    
// Add section-specific JavaScript here
// This runs once when the section is loaded

  } catch(e) { console.error(e); }
})();
})();
